// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__2wjux","Cloud":"Layout_Cloud__2kMwx","animate":"Layout_animate__2O2KI"};